import {delete_request, get, post} from '../http';

export default function getApi({ isMock = false } = {}) {
    const service = 'progress';

    let mockRequest = (res) => new Promise((r, j) => {
        setTimeout(() => {
            console.log(res);
            r(res);
        }, 1000);
    });

    let api = {
        async createTrack() {
            return await post(service, `api/v2/user/tracks`);
        },
        async fetchTracks() {
            return await get(service, `api/v2/user/tracks`);
        },
        async fetchTrack(trackId) {
            return await get(service, `api/v2/user/tracks/${trackId}`);
        },
        async fetchTrackCompetences(trackId) {
            return (await get(service, `api/v2/user/tracks/${trackId}/competences`));
        },
        
        async fetchTrackCompetenceById(trackId, competenceId) {
            return (await get(service, `api/v2/user/tracks/${trackId}/competences/${competenceId}`));
        },
        async addCompetenceToTrack(trackId, competenceId) {
            return (await post(service, `api/v2/user/tracks/${trackId}/competences/${competenceId}`, {}, true));
        },
        async addProfessionToTrack(trackId, profId) {
            return (await post(service, `api/v2/user/profiles/${profId}`, { trackId }, true));
        },
        async fetchTrackPrograms(trackId) {
            return (await get(service, `api/v2/user/programs`, {
                'filter[trackId]': trackId,
                'withCompetences': true,
                'withInstitute': true,
                'withModules': true,
            }));
        },
        async updateProgramStatus(programId, { action, startAt = null, moduleId = null }) {
            return (await post(service, `api/v2/user/programs/${programId}/track:action`, {
                action,
                startAt,
                moduleId,
            }, true));
        },
        async updateProgram(programId, { trackId }) {
            return (await post(service, `api/v2/user/programs/${programId}`, {
                trackId,
            }, true));
        },
        async loadUserCompetences() {
            return (await get(service, `api/v2/user/competences`));
        },
        async addTrackCompetence(competenceId, { trackId }) {
            return (await post(service, `api/v2/user/tracks/${trackId}/competences/${competenceId}`, {}, true));
        },
        async removeTrackCompetence(competenceId, { trackId }) {
            return (await delete_request(service, `api/v2/user/tracks/${trackId}/competences/${competenceId}`));
        },
        async updateCompetence(competenceId, { userAcknowledgment }) {
            return (await post(service, `api/v2/user/competences/${competenceId}`, {
                userAcknowledgment,
            }, true));
        },
        async fetchTrackProfiles(trackId, { view = null }) {
            view = view ? `:view${view}` : '';
            return await get(service, `api/v2/user/profiles${view}`, {
                'filter[trackId]': trackId,
            });
        },
        async removeTrackProfile(id) {
            return await delete_request(service, `api/v2/user/profiles/${id}`);
        },
        async fetchUserProfile(profileId) {
            try {
                return await get(service, `api/v2/user/profiles/${profileId}`);
            } catch (e) {
                return null;
            }
        },
        async fetchProfession(id) {
            let res = await get(service, `profiles`, {
                'filter[id]': id,
            });
            if (!res || !res.profiles || !res.profiles.length) {
                return null;
            }
            return res.profiles[0];
        },
        async fetchProfessionPrograms(professionId, { limit, offset, filter = {} }) {
            try {
                const filterString = {};
                Object.keys(filter).forEach((key) => {
                    if (
                        key === 'durationInterval'
                        && filter.durationInterval
                    ) {
                        filterString['filter[durationInterval][min]'] = filter.durationInterval.min;
                        filterString['filter[durationInterval][max]'] = filter.durationInterval.max;
                    } else if (
                        key === 'startOfStudy'
                        && filter.startOfStudy
                    ) {
                        if (filter.startOfStudy.min !== '') {
                            filterString['filter[startOfStudy][min]'] = filter.startOfStudy.min;
                        }
                        if (filter.startOfStudy.max !== '') {
                            filterString['filter[startOfStudy][max]'] = filter.startOfStudy.max;
                        }
                    } else if (
                        key === 'costOfStudy'
                        && filter.costOfStudy
                    ) {
                        if (filter.costOfStudy.min !== '') {
                            filterString['filter[costOfStudy][min]'] = filter.costOfStudy.min;
                        }
                        if (filter.costOfStudy.max !== '') {
                            filterString['filter[costOfStudy][max]'] = filter.costOfStudy.max;
                        }
                        filterString['filter[costOfStudy][isFree]'] = filter.costOfStudy.isFree;
                    } else {
                        filterString[`filter[${key}]`] = filter[key];
                    }
                });
                const res = await get(service, `api/v2/profiles/${professionId}/programs:viewSearchStudy`, {
                    limit,
                    offset,
                    ...filterString,
                });
                if (!res || !res.items) {
                    return {
                        items: [],
                        total: 0,
                    };;
                }
                return {
                    items: res.items,
                    total: res.total,
                };
            } catch (e) {
                console.error(e);
            }
        },
        async fetchUserPrograms(programIds) {
            try {
                if (programIds.length) {
                    let filterString = '';
                    for (let id of programIds) {
                        filterString += `filter[programIds][]=${id}&`;
                    }
                    const res = await get(service, `api/v2/user/programs?${filterString}`);
                    if (!res || !res.items || !res.items.length) {
                        return null;
                    }
                    return res;
                }
                return null;
            } catch (e) {
                console.error(e);
            }
        },
        async addProgramToTrack(trackId, programId) {
            try {
                return await post(service, `api/v2/user/programs/${programId}`, {
                    trackId: trackId,
                }, true);
            } catch (e) {
                console.error(e);
            }
        },
        async fetchCategory(id) {
            let res = await get(service, `professions`, {
                'filter[id]': id,
            });
            if (!res || !res.professions || !res.professions.length) {
                return null;
            }
            return res.professions[0];
        },
        async fetchSpecializationsBulk(ids) {
            if (!ids || ids.length === 0) { return []; }
            let query = ids.map(id => `filter[ids][]=${id}`).join('&');
            let specializations;
            try {
                const response = await get(service, `profiles-list?${query}`);
                if (!response || !response.profiles ) {
                    specializations = [];
                } else { 
                    specializations = response.profiles;
                }
            } catch (error) {
                specializations = [];
            }
            return specializations;
        },
        async fetchSpecialTest(key) {
            try {
                return await get(service, `api/v2/tests/${key}`);
            } catch (e) {
                return null;
            }
        },
        async fetchRecommendedProfessions() {
            let res = await get(service, `api/v2/user/recommendations/profiles`);
            if (res) {
                return res.items;
            } else {
                return [];
            }
        },
    };

    if (isMock) {
        api = {
            fetchTrack(trackId) {
                return mockRequest({
                    "id": 1,
                    "name": "Основной трек развития",
                    "status": "active",
                    "completedAt": "2020-11-09T12:19:17.255Z",
                    "createdAt": "2020-11-09T12:19:17.255Z",
                });
            },
            fetchTracks(trackId) {
                return mockRequest({
                    "items": [
                        {
                            "id": 1,
                            "name": "Основной трек развития",
                            "status": "active",
                            "completedAt": "2020-11-19T13:53:45.167Z",
                            "createdAt": "2020-11-19T13:53:45.167Z",
                        },
                    ],
                    "total": 1,
                });
            },
            fetchTrackPage() {
                return mockRequest({
                    list: [],
                });
            },
            fetchTrackCompetences(trackId) {
                return mockRequest({
                    items: [
                        {
                            "id": 1,
                            "name": "Обучениево время работы",
                            "requiredLevel": "intermediate",
                            "competenceLevel": "intermediate",
                            "userAcknowledgment": true,
                            "updatedAt": "2020-11-09T12:19:42.056Z",
                            "competenceType": "soft",
                            "isDirect": false,
                        },
                        {
                            "id": 2,
                            "name": "Креативность",
                            "requiredLevel": "intermediate",
                            "competenceLevel": "intermediate",
                            "userAcknowledgment": true,
                            "updatedAt": "2020-12-09T12:19:42.056Z",
                            "competenceType": "soft",
                            "isDirect": false,
                        },
                        {
                            "id": 3,
                            "name": "Адаптивность",
                            "requiredLevel": "basic",
                            "competenceLevel": "basic",
                            "userAcknowledgment": true,
                            "updatedAt": "2020-11-09T12:19:42.056Z",
                            "competenceType": "soft",
                            "isDirect": false,
                        },
                        {
                            "id": 4,
                            "name": "Обучение во время работы",
                            "requiredLevel": "advanced",
                            "competenceLevel": "advanced",
                            "userAcknowledgment": true,
                            "updatedAt": "2020-11-09T12:19:42.056Z",
                            "competenceType": "soft",
                            "isDirect": false,
                        },
                        {
                            "id": 5,
                            "name": "Креативность",
                            "requiredLevel": "advanced",
                            "competenceLevel": "advanced",
                            "userAcknowledgment": true,
                            "updatedAt": "2020-11-09T12:19:42.056Z",
                            "competenceType": "soft",
                            "isDirect": false,
                        },
                        {
                            "id": 6,
                            "name": "Адаптивность",
                            "requiredLevel": "basic",
                            "competenceLevel": "basic",
                            "userAcknowledgment": true,
                            "updatedAt": "2020-11-09T12:19:42.056Z",
                            "competenceType": "hard",
                            "isDirect": true,
                        },
                        {
                            "id": 7,
                            "name": "Критическое мышление и анализ всего 4 строки",
                            "requiredLevel": "advanced",
                            "competenceLevel": "advanced",
                            "userAcknowledgment": true,
                            "updatedAt": "2020-11-09T12:19:42.056Z",
                            "competenceType": "hard",
                            "isDirect": true,
                        },
                        {
                            "id": 8,
                            "name": "Тайм-менеджмент",
                            "requiredLevel": "advanced",
                            "competenceLevel": "advanced",
                            "userAcknowledgment": true,
                            "updatedAt": "2020-11-09T12:19:42.056Z",
                            "competenceType": "soft",
                            "isDirect": false,
                        },
                        {
                            "id": 9,
                            "name": "Диагностика, ремонт, эксплуатация профессиональ...",
                            "requiredLevel": "basic",
                            "competenceLevel": "basic",
                            "userAcknowledgment": true,
                            "updatedAt": "2020-11-09T12:19:42.056Z",
                            "competenceType": "hard",
                            "isDirect": true,
                        },
                        {
                            "id": 10,
                            "name": "Владение проф. программными продуктами",
                            "requiredLevel": "advanced",
                            "competenceLevel": "advanced",
                            "userAcknowledgment": false,
                            "updatedAt": "2020-11-09T12:19:42.056Z",
                            "competenceType": "hard",
                            "isDirect": false,
                        },
                        {
                            "id": 11,
                            "name": "Контроль качества",
                            "requiredLevel": "advanced",
                            "competenceLevel": "advanced",
                            "userAcknowledgment": null,
                            "updatedAt": "2020-11-09T12:19:42.056Z",
                            "competenceType": "hard",
                            "isDirect": false,
                        },
                        {
                            "id": 12,
                            "name": "Диагностика, ремонт, эксплуатация профессиональ...",
                            "requiredLevel": "basic",
                            "competenceLevel": "basic",
                            "userAcknowledgment": true,
                            "updatedAt": "2020-11-09T12:19:42.056Z",
                            "competenceType": "hard",
                        },
                        {
                            "id": 13,
                            "name": "Владение проф. программными продуктами",
                            "requiredLevel": "advanced",
                            "competenceLevel": "advanced",
                            "userAcknowledgment": false,
                            "updatedAt": "2020-11-09T12:19:42.056Z",
                            "competenceType": "hard",
                        },
                        {
                            "id": 14,
                            "name": "Контроль качества",
                            "requiredLevel": "advanced",
                            "competenceLevel": "advanced",
                            "userAcknowledgment": null,
                            "updatedAt": "2020-11-09T12:19:42.056Z",
                            "competenceType": "hard",
                        },
                        {
                            "id": 9,
                            "name": "Диагностика, ремонт, эксплуатация профессиональ...",
                            "requiredLevel": "basic",
                            "competenceLevel": "basic",
                            "userAcknowledgment": true,
                            "updatedAt": "2020-11-09T12:19:42.056Z",
                            "competenceType": "hard",
                        },
                        {
                            "id": 79,
                            "name": "Владение проф. программными продуктами",
                            "requiredLevel": "advanced",
                            "competenceLevel": "advanced",
                            "userAcknowledgment": false,
                            "updatedAt": "2020-11-09T12:19:42.056Z",
                            "competenceType": "hard",
                        },
                        {
                            "id": 89,
                            "name": "Контроль качества",
                            "requiredLevel": "advanced",
                            "competenceLevel": "advanced",
                            "userAcknowledgment": null,
                            "updatedAt": "2020-11-09T12:19:42.056Z",
                            "competenceType": "hard",
                        },
                    ],
                });
            },
            fetchTrackPrograms(trackId) {
                return mockRequest({
                    items: [
                        {
                            "id": 1,
                            "name": "Онлайн курс HTML мастер 2020",
                            "educationType": "rsv_webinar",
                            "startAt": null,
                            "foreignEventId": 0,
                            "status": "planned",
                            "completedAt": "2020-11-09T12:20:09.611Z",
                            "trackId": 1,
                            "durationInterval": "P0Y1M0DT0H0M",
                            "isAnyTimeStart": true,
                            "programBeginnings": [
                                {
                                    "id": 0,
                                    "date": "2020-11-09",
                                    "interval": "P0Y1M0DT0H0M",
                                },
                            ],
                            "competences": [
                                {
                                    "id": 1,
                                    "name": 1,
                                    "sortIndex": 1,
                                    "acquiredLevel": "basic",
                                    "competenceType": "soft",
                                },
                                {
                                    "id": 7,
                                    "name": 7,
                                    "sortIndex": 1,
                                    "acquiredLevel": "basic",
                                    "competenceType": "hard",
                                },
                            ],
                            "link": "string",
                            "syllabusUrl": "string",
                        },
                        {
                            "id": 12,
                            "name": "Онлайн курс HTML мастер 2020",
                            "educationType": "rsv_webinar",
                            "startAt": "2020-12-15",
                            "foreignEventId": 0,
                            "status": "planned",
                            "completedAt": "2020-11-09T12:20:09.611Z",
                            "trackId": 1,
                            "durationInterval": "P0Y1M0DT0H0M",
                            "isAnyTimeStart": true,
                            "programBeginnings": [
                                {
                                    "id": 0,
                                    "date": "2020-11-09",
                                    "interval": "P0Y1M0DT0H0M",
                                },
                                {
                                    "id": 0,
                                    "date": "2020-11-09",
                                    "interval": "P0Y0M12DT0H0M",
                                },
                                {
                                    "id": 0,
                                    "date": "2020-11-09",
                                    "interval": "P0Y0M5DT0H0M",
                                },
                                {
                                    "id": 0,
                                    "date": "2020-11-09",
                                    "interval": "P0Y0M3DT0H0M",
                                },
                            ],
                            "competences": [
                                {
                                    "id": 1,
                                    "name": 1,
                                    "sortIndex": 1,
                                    "acquiredLevel": "basic",
                                    "competenceType": "soft",
                                },
                                {
                                    "id": 6,
                                    "name": 6,
                                    "sortIndex": 1,
                                    "acquiredLevel": "basic",
                                    "competenceType": "hard",
                                },
                            ],
                            "link": "string",
                            "syllabusUrl": "string",
                        },
                        {
                            "id": 3,
                            "name": "Онлайн курс HTML мастер 2020",
                            "educationType": "rsv_webinar",
                            "startAt": "2020-12-15",
                            "foreignEventId": 0,
                            "status": "planned",
                            "completedAt": "2020-11-09T12:20:09.611Z",
                            "trackId": 1,
                            "durationInterval": "P0Y1M0DT0H0M",
                            "isAnyTimeStart": false,
                            "programBeginnings": [
                                {
                                    "id": 0,
                                    "date": "2020-11-09",
                                    "interval": "P0Y1M0DT0H0M",
                                },
                            ],
                            "competences": [
                                {
                                    "id": 1,
                                    "name": 1,
                                    "sortIndex": 1,
                                    "acquiredLevel": "basic",
                                    "competenceType": "soft",
                                },
                                {
                                    "id": 6,
                                    "name": 6,
                                    "sortIndex": 1,
                                    "acquiredLevel": "basic",
                                    "competenceType": "hard",
                                },
                            ],
                            "link": "string",
                            "syllabusUrl": "string",
                        },
                        {
                            "id": 4,
                            "name": "Онлайн курс HTML мастер 2020",
                            "educationType": "rsv_webinar",
                            "startAt": null,
                            "foreignEventId": 0,
                            "status": "planned",
                            "completedAt": "2020-11-09T12:20:09.611Z",
                            "trackId": 1,
                            "durationInterval": "P0Y1M0DT0H0M",
                            "isAnyTimeStart": false,
                            "programBeginnings": [
                                {
                                    "id": 0,
                                    "date": "2020-11-09",
                                    "interval": "P0Y1M0DT0H0M",
                                },
                            ],
                            "competences": [
                                {
                                    "id": 1,
                                    "name": 1,
                                    "sortIndex": 1,
                                    "acquiredLevel": "basic",
                                    "competenceType": "soft",
                                },
                            ],
                            "link": "string",
                            "syllabusUrl": "string",
                        },
                        {
                            "id": 45,
                            "name": "Онлайн курс HTML мастер 2020",
                            "educationType": "rsv_webinar",
                            "startAt": "2020-12-15",
                            "foreignEventId": 0,
                            "status": "planned",
                            "completedAt": "2020-11-09T12:20:09.611Z",
                            "trackId": 1,
                            "durationInterval": "P0Y1M0DT0H0M",
                            "isAnyTimeStart": true,
                            "programBeginnings": [
                                {
                                    "id": 0,
                                    "date": "2020-11-09",
                                    "interval": "P0Y1M0DT0H0M",
                                },
                            ],
                            "competences": [
                                {
                                    "id": 1,
                                    "name": 1,
                                    "sortIndex": 1,
                                    "acquiredLevel": "basic",
                                    "competenceType": "soft",
                                },
                            ],
                            "link": "string",
                            "syllabusUrl": "string",
                        },
                        {
                            "id": 5,
                            "name": "Онлайн курс HTML мастер 2020",
                            "educationType": "rsv_webinar",
                            "startAt": "2020-12-15",
                            "foreignEventId": 0,
                            "status": "planned",
                            "completedAt": "2020-11-09T12:20:09.611Z",
                            "trackId": 1,
                            "durationInterval": "P0Y1M0DT0H0M",
                            "isAnyTimeStart": true,
                            "programBeginnings": [
                                {
                                    "id": 0,
                                    "date": "2020-11-09",
                                    "interval": "P0Y1M0DT0H0M",
                                },
                            ],
                            "competences": [
                                {
                                    "id": 1,
                                    "name": 1,
                                    "sortIndex": 1,
                                    "acquiredLevel": "basic",
                                    "competenceType": "soft",
                                },
                            ],
                            "link": "string",
                            "syllabusUrl": "string",
                        },
                        {
                            "id": 6,
                            "name": "Онлайн курс HTML мастер 2020",
                            "educationType": "rsv_webinar",
                            "startAt": "2020-12-15",
                            "foreignEventId": 0,
                            "status": "planned",
                            "completedAt": "2020-11-09T12:20:09.611Z",
                            "trackId": 1,
                            "durationInterval": "P0Y1M0DT0H0M",
                            "isAnyTimeStart": true,
                            "programBeginnings": [
                                {
                                    "id": 0,
                                    "date": "2020-11-09",
                                    "interval": "P0Y1M0DT0H0M",
                                },
                            ],
                            "competences": [
                                {
                                    "id": 1,
                                    "name": 1,
                                    "sortIndex": 1,
                                    "acquiredLevel": "basic",
                                    "competenceType": "soft",
                                },
                            ],
                            "link": "string",
                            "syllabusUrl": "string",
                        },
                        {
                            "id": 7,
                            "name": "Онлайн курс HTML мастер 2020",
                            "educationType": "rsv_webinar",
                            "startAt": "2020-12-15",
                            "foreignEventId": 0,
                            "status": "planned",
                            "completedAt": "2020-11-09T12:20:09.611Z",
                            "trackId": 1,
                            "durationInterval": "P0Y1M0DT0H0M",
                            "isAnyTimeStart": true,
                            "programBeginnings": [
                                {
                                    "id": 0,
                                    "date": "2020-11-09",
                                    "interval": "P0Y1M0DT0H0M",
                                },
                            ],
                            "competences": [
                                {
                                    "id": 1,
                                    "name": 1,
                                    "sortIndex": 1,
                                    "acquiredLevel": "basic",
                                    "competenceType": "soft",
                                },
                            ],
                            "link": "string",
                            "syllabusUrl": "string",
                        },
                        {
                            "id": 8,
                            "name": "Онлайн курс HTML мастер 2020",
                            "educationType": "rsv_webinar",
                            "startAt": "2020-12-15",
                            "foreignEventId": 0,
                            "status": "planned",
                            "completedAt": "2020-11-09T12:20:09.611Z",
                            "trackId": 1,
                            "durationInterval": "P0Y1M0DT0H0M",
                            "isAnyTimeStart": true,
                            "programBeginnings": [
                                {
                                    "id": 0,
                                    "date": "2020-11-09",
                                    "interval": "P0Y1M0DT0H0M",
                                },
                            ],
                            "competences": [
                                {
                                    "id": 1,
                                    "name": 1,
                                    "sortIndex": 1,
                                    "acquiredLevel": "basic",
                                    "competenceType": "soft",
                                },
                            ],
                            "link": "string",
                            "syllabusUrl": "string",
                        },
                        {
                            "id": 9,
                            "name": "Онлайн курс HTML мастер 2020",
                            "educationType": "rsv_webinar",
                            "startAt": "2020-12-15",
                            "foreignEventId": 0,
                            "status": "planned",
                            "completedAt": "2020-11-09T12:20:09.611Z",
                            "trackId": 1,
                            "durationInterval": "P0Y1M0DT0H0M",
                            "isAnyTimeStart": true,
                            "programBeginnings": [
                                {
                                    "id": 0,
                                    "date": "2020-11-09",
                                    "interval": "P0Y1M0DT0H0M",
                                },
                            ],
                            "competences": [
                                {
                                    "id": 1,
                                    "name": 1,
                                    "sortIndex": 1,
                                    "acquiredLevel": "basic",
                                    "competenceType": "soft",
                                },
                            ],
                            "link": "string",
                            "syllabusUrl": "string",
                        },
                        {
                            "id": 10,
                            "name": "Онлайн курс HTML мастер 2020",
                            "educationType": "rsv_webinar",
                            "startAt": "2020-12-15",
                            "foreignEventId": 0,
                            "status": "planned",
                            "completedAt": "2020-11-09T12:20:09.611Z",
                            "trackId": 1,
                            "durationInterval": "P0Y1M0DT0H0M",
                            "isAnyTimeStart": true,
                            "programBeginnings": [
                                {
                                    "id": 0,
                                    "date": "2020-11-09",
                                    "interval": "P0Y1M0DT0H0M",
                                },
                            ],
                            "competences": [
                                {
                                    "id": 1,
                                    "name": 1,
                                    "sortIndex": 1,
                                    "acquiredLevel": "basic",
                                    "competenceType": "soft",
                                },
                            ],
                            "link": "string",
                            "syllabusUrl": "string",
                        },
                        {
                            "id": 1123,
                            "name": "Онлайн курс HTML мастер 2020",
                            "educationType": "rsv_webinar",
                            "startAt": "2020-11-01",
                            "foreignEventId": 0,
                            "status": "planned",
                            "completedAt": "2020-11-09T12:20:09.611Z",
                            "trackId": 1,
                            "durationInterval": "P0Y0M1DT0H0M",
                            "isAnyTimeStart": true,
                            "programBeginnings": [
                                {
                                    "id": 0,
                                    "date": "2020-11-09",
                                    "interval": "P0Y1M0DT0H0M",
                                },
                            ],
                            "competences": [
                                {
                                    "id": 1,
                                    "name": 1,
                                    "sortIndex": 1,
                                    "acquiredLevel": "basic",
                                    "competenceType": "soft",
                                },
                            ],
                            "link": "string",
                            "syllabusUrl": "string",
                        },
                        {
                            "id": 1234,
                            "name": "Онлайн курс HTML мастер 2020",
                            "educationType": "rsv_webinar",
                            "startAt": "2020-11-08",
                            "foreignEventId": 0,
                            "status": "started",
                            "completedAt": "2020-11-09T12:20:09.611Z",
                            "trackId": 1,
                            "durationInterval": "P0Y0M1DT0H0M",
                            "isAnyTimeStart": true,
                            "programBeginnings": [
                                {
                                    "id": 0,
                                    "date": "2020-11-09",
                                    "interval": "P0Y1M0DT0H0M",
                                },
                            ],
                            "competences": [
                                {
                                    "id": 1,
                                    "name": 1,
                                    "sortIndex": 1,
                                    "acquiredLevel": "basic",
                                    "competenceType": "soft",
                                },
                            ],
                            "link": "string",
                            "syllabusUrl": "string",
                        },
                        {
                            "id": 1345,
                            "name": "Онлайн курс HTML мастер 2020",
                            "educationType": "rsv_course",
                            "startAt": null,
                            "foreignEventId": 0,
                            "status": "planned",
                            "completedAt": "2020-11-09T12:20:09.611Z",
                            "trackId": 1,
                            "durationInterval": "P0Y0M1DT0H0M",
                            "isAnyTimeStart": true,
                            "programBeginnings": [
                                {
                                    "id": 0,
                                    "date": "2020-11-09",
                                    "interval": "P0Y1M0DT0H0M",
                                },
                            ],
                            "competences": [
                                {
                                    "id": 1,
                                    "name": 1,
                                    "sortIndex": 1,
                                    "acquiredLevel": "basic",
                                    "competenceType": "soft",
                                },
                            ],
                            "link": "string",
                            "syllabusUrl": "string",
                        },
                        {
                            "id": 1231,
                            "name": "Онлайн курс HTML мастер 2020",
                            "educationType": "rsv_webinar",
                            "startAt": "2020-11-22",
                            "foreignEventId": 0,
                            "status": "planned",
                            "completedAt": "2020-11-09T12:20:09.611Z",
                            "trackId": 1,
                            "durationInterval": "P0Y0M3DT0H0M",
                            "isAnyTimeStart": true,
                            "programBeginnings": [
                                {
                                    "id": 0,
                                    "date": "2020-11-09",
                                    "interval": "P0Y1M0DT0H0M",
                                },
                            ],
                            "competences": [
                                {
                                    "id": 1,
                                    "name": 1,
                                    "sortIndex": 1,
                                    "acquiredLevel": "basic",
                                    "competenceType": "soft",
                                },
                            ],
                            "link": "string",
                            "syllabusUrl": "string",
                        },
                        {
                            "id": 2342,
                            "name": "A",
                            "educationType": "higher",
                            "startAt": "2020-10-01",
                            "foreignEventId": 0,
                            "status": "completed",
                            "completedAt": "2020-11-09T12:20:09.611Z",
                            "trackId": 1,
                            "durationInterval": "P0Y0M31DT0H0M",
                            "isAnyTimeStart": true,
                            "programBeginnings": [
                                {
                                    "id": 0,
                                    "date": "2020-11-09",
                                    "interval": "P0Y1M0DT0H0M",
                                },
                            ],
                            "competences": [
                                {
                                    "id": 1,
                                    "name": 1,
                                    "sortIndex": 1,
                                    "acquiredLevel": "basic",
                                    "competenceType": "soft",
                                },
                            ],
                            "link": "string",
                            "syllabusUrl": "string",
                        },
                        {
                            "id": 3453,
                            "name": "Графический дизайн и рекламадатель и длинный текст который не влез",
                            "educationType": "higher",
                            "startAt": null,
                            "foreignEventId": 0,
                            "status": "planned",
                            "completedAt": "2020-11-09T12:20:09.611Z",
                            "trackId": 1,
                            "durationInterval": "P0Y22M15DT0H0M",
                            "isAnyTimeStart": true,
                            "programBeginnings": [
                                {
                                    "id": 0,
                                    "date": "2020-11-09",
                                    "interval": "P0Y1M0DT0H0M",
                                },
                            ],
                            "competences": [
                                {
                                    "id": 1,
                                    "name": 1,
                                    "sortIndex": 1,
                                    "acquiredLevel": "basic",
                                    "competenceType": "soft",
                                },
                            ],
                            "link": "string",
                            "syllabusUrl": "string",
                        },
                        {
                            "id": 4564,
                            "name": "A",
                            "educationType": "higher",
                            "startAt": "2020-10-01",
                            "foreignEventId": 0,
                            "status": "planned",
                            "completedAt": "2020-11-09T12:20:09.611Z",
                            "trackId": 1,
                            "durationInterval": "P1Y0M31DT0H0M",
                            "isAnyTimeStart": true,
                            "programBeginnings": [
                                {
                                    "id": 0,
                                    "date": "2020-11-09",
                                    "interval": "P0Y1M0DT0H0M",
                                },
                            ],
                            "competences": [
                                {
                                    "id": 1,
                                    "name": 1,
                                    "sortIndex": 1,
                                    "acquiredLevel": "basic",
                                    "competenceType": "soft",
                                },
                            ],
                            "link": "string",
                            "syllabusUrl": "string",
                        },
                        {
                            "id": 5675,
                            "name": "B",
                            "educationType": "rsv_course",
                            "startAt": "2020-11-01",
                            "foreignEventId": 0,
                            "status": "planned",
                            "completedAt": "2020-11-09T12:20:09.611Z",
                            "trackId": 1,
                            "durationInterval": "P0Y5M0DT0H0M",
                            "isAnyTimeStart": true,
                            "programBeginnings": [
                                {
                                    "id": 0,
                                    "date": "2020-11-09",
                                    "interval": "P0Y1M0DT0H0M",
                                },
                            ],
                            "competences": [
                                {
                                    "id": 1,
                                    "name": 1,
                                    "sortIndex": 1,
                                    "acquiredLevel": "basic",
                                    "competenceType": "soft",
                                },
                            ],
                            "link": "string",
                            "syllabusUrl": "string",
                        },
                        {
                            "id": 6786,
                            "name": "C",
                            "educationType": "higher",
                            "startAt": "2020-11-01",
                            "foreignEventId": 0,
                            "status": "started",
                            "completedAt": "2020-11-09T12:20:09.611Z",
                            "trackId": 1,
                            "durationInterval": "P0Y1M10DT0H0M",
                            "isAnyTimeStart": true,
                            "programBeginnings": [
                                {
                                    "id": 0,
                                    "date": "2020-11-09",
                                    "interval": "P0Y1M0DT0H0M",
                                },
                            ],
                            "competences": [
                                {
                                    "id": 1,
                                    "name": 1,
                                    "sortIndex": 1,
                                    "acquiredLevel": "basic",
                                    "competenceType": "soft",
                                },
                            ],
                            "link": "string",
                            "syllabusUrl": "string",
                        },
                    ],
                });
            },
            updateProgramStatus(programId, { action, startAt = null}) {
                let status = null;
                switch (action) {
                    case 'schedule':
                        status = 'planned';
                        break;
                    case 'cancel':
                        status = null;
                        break;
                    case 'start':
                        status = 'started';
                        break;
                    case 'complete':
                        status = 'completed';
                        break;
                }
                return mockRequest({
                    "id": programId,
                    "educationType": "higher",
                    "entityType": "program",
                    "startAt": "2018-09-01", //"2020-11-09"
                    "foreignEventId": null,
                    "status": status,
                    "completedAt": null, //"2020-11-09T12:20:53.084Z"
                    "trackId": 1,
                    "durationInterval": "P1Y0M0DT0H0M",
                    "isAnyTimeStart": true,
                    "institute": {
                        "id": 1,
                        "name": "«Россия — страна возможностей»",
                        "logo": {
                            "id": 1,
                            "url": "https://s3-profile.rsv.ru/3bb062bd528284943d5947266140c56090e8addab0f4f64582e414b98c3bff24.png",
                        },
                    },
                    "programBeginnings": [
                        {
                            "id": 0,
                            "date": "2020-11-09",
                            "interval": "P0Y1M0DT0H0M",
                        },
                    ],
                    "competences": [
                        {
                            "id": 1,
                            "name": 1,
                            "sortIndex": 1,
                            "acquiredLevel": "basic",
                            "competenceType": "soft",
                        },
                    ],
                    "link": "string",
                    "syllabusUrl": "string",
                });
            },
            updateProgram(programId, { trackId }) {
                return mockRequest({
                    "id": 12345675,
                    "educationType": "higher",
                    "startAt": "2020-11-09",
                    "foreignEventId": 0,
                    "status": "planned",
                    "completedAt": "2020-11-09T12:20:53.084Z",
                    "trackId": 1,
                    "durationInterval": "P1Y0M0DT0H0M",
                    "isAnyTimeStart": true,
                    "programBeginnings": [
                        {
                            "id": 0,
                            "date": "2020-11-09",
                            "interval": "P0Y1M0DT0H0M",
                        },
                    ],
                    "competences": [
                        {
                            "id": 1,
                            "name": 1,
                            "sortIndex": 1,
                            "acquiredLevel": "basic",
                            "competenceType": "soft",
                        },
                    ],
                    "link": "string",
                    "syllabusUrl": "string",
                });
            },
            updateCompetence(competenceId, { userAcknowledgment }) {
                return mockRequest({
                    "id": 1,
                    "name": "string",
                    "requiredLevel": "basic",
                    "competenceLevel": "basic",
                    "userAcknowledgment": userAcknowledgment,
                    "updatedAt": "2020-11-09T12:19:42.056Z",
                });
            },
            fetchTrackProfiles(trackId) {
                return mockRequest({
                    items: [
                        {
                            "id": 1,
                            "trackId": 1,
                            "name": 'Инженер 1',
                        },
                        {
                            "id": 2,
                            "trackId": 1,
                            "name": 'Инженер 2',
                        },
                    ],
                });
            },
        };
    }
    return api;
}
